import axios from "axios";
import env from "../../env/src_config";


export const setOrgParamsPublic = (organizationName, postHeaders) => {

    const postData = { 
        organizationName, 
        // organization: env.frontend[this.props.organization.organization]['o'],
    }
    
    axios.post(env.api.public + 'licence-data', postData, postHeaders).then(response => {
        localStorage.setItem('E-DRAZBE.licenceData-Public', JSON.stringify(response.data));
    });
}